import React from "react";
import RenderImage from "./RenderImage";
import { cn } from "../../utils/cn";
import { AVATAR_VARIANT } from "../../constants/commonConstants";

const Avatar = ({
  src,
  alt = "Avatar",
  variant = AVATAR_VARIANT.CIRCLE,
  className = "",
  imageClassName = "",
  fallbackSrc = null,
  placeholderImage = "",
  fallback = null,
  objectFit = "object-cover",
  loading = false,
  effect = "blur",
  onClick = null,
  ...props
}) => {
  return (
    <div className={cn("avatar-base", variant, className)} onClick={onClick}>
      <RenderImage
        src={src}
        alt={alt}
        className={cn("w-full h-full", variant)}
        imageClassName={cn("w-full h-full", objectFit, variant, imageClassName)}
        fallbackSrc={fallbackSrc}
        placeholderImage={placeholderImage}
        fallback={fallback}
        rounded={variant}
        loading={loading}
        effect={effect}
        {...props}
      />
    </div>
  );
};

export default Avatar;
